// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__rd6wL","col":"Table_col__3Ohy6","fulfillmentStatus":"Table_fulfillmentStatus__2AQYJ","emailCol":"Table_emailCol__1z7sw"};